/**
 * Node modules
 */
import styled from 'styled-components';

/**
 * Private modules
 */
import { scale } from '../.private';

/**
 * Styled components
 */
export default styled.div`
  align-items: center;
  border-bottom: ${scale.minor(0.25)}px solid rgba(189, 195, 199, 1);
  display: flex;
  font-size: ${scale.minor(4)}px;
  padding: ${scale.major(1)}px ${scale.major(2)}px;
  height: ${scale.minor(11)}px;
  svg {
    height: ${scale.minor(5)}px;
    margin-right: ${scale.minor(1)}px;
    width: ${scale.minor(5)}px;
  }
  > span {
    :last-child {
      margin-left: auto;
    }
    :nth-child(3)::before {
      content: '|';
      margin-left: ${scale.minor(1)}px;
      margin-right: ${scale.minor(1)}px;
    }
  }
`;
